import { Action } from 'redux';
import * as Actions from './actionTypes';
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions';
import { ServiceContractPayment, ServiceContractPaymentRecordsFilters } from 'src/common/models/serviceContractDebitPayment';
import { CashboxStatement, CashboxStmtRecordsFilters } from 'src/common/models/cashboxStatement';

export interface CreateContractPaymentAction extends Action {
    contractPayment: ServiceContractPayment
}
export interface CreateContractPaymentSuccessAction extends Action {
    contractPayment: ServiceContractPayment
}
export const createContractPaymentApi = (contractPayment: ServiceContractPayment): CreateContractPaymentAction => ({
    type: Actions.CREATE_CONTRACT_PAYMENT_API,
    contractPayment,
})
export const createContractPaymentApiSuccess = (contractPayment: ServiceContractPayment): CreateContractPaymentSuccessAction => ({
    type: Actions.CREATE_CONTRACT_PAYMENT_API_SUCCESS,
    contractPayment,
})
export const createContractPaymentApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.CREATE_CONTRACT_PAYMENT_API_ERROR,
    error,
)

export interface GetCashboxStmtRecordsAction extends Action {
    filters?: CashboxStmtRecordsFilters
}
export interface GetCashboxStmtRecordsSuccessAction extends Action {
    cashboxStatements: CashboxStatement[],
    balance: number,
}
export const getCashboxStmtRecordsApi = (filters?: CashboxStmtRecordsFilters): GetCashboxStmtRecordsAction => ({
    type: Actions.GET_CASHBOX_STATEMENT_RECORDS_API,
    filters,
})
export const getCashboxStmtRecordsApiSuccess = (cashboxStatements: CashboxStatement[], balance: number): GetCashboxStmtRecordsSuccessAction => ({
    type: Actions.GET_CASHBOX_STATEMENT_RECORDS_API_SUCCESS,
    cashboxStatements,
    balance,
})
export const getCashboxStmtRecordsApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_CASHBOX_STATEMENT_RECORDS_API_ERROR,
    error,
)

export interface GetContractPaymentRecordsAction extends Action {
    filters?: ServiceContractPaymentRecordsFilters
}
export interface GetContractPaymentRecordsSuccessAction extends Action {
    contractPayments: ServiceContractPayment[]
}
export const getContractPaymentRecordsApi = (filters?: ServiceContractPaymentRecordsFilters): GetContractPaymentRecordsAction => ({
    type: Actions.GET_CONTRACT_PAYMENT_RECORDS_API,
    filters,
})
export const getContractPaymentRecordsApiSuccess = (contractPayments: ServiceContractPayment[]): GetContractPaymentRecordsSuccessAction => ({
    type: Actions.GET_CONTRACT_PAYMENT_RECORDS_API_SUCCESS,
    contractPayments,
})
export const getContractPaymentRecordsApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_CONTRACT_PAYMENT_RECORDS_API_ERROR,
    error,
)

export interface SendPaymentContractReceiptAction extends Action {
    paymentRecordIds: number[]
}
export interface SendPaymentContractReceiptSuccessAction extends Action {
    success: boolean
}
export const sendPaymentContractReceiptApi = (paymentRecordIds: number[]): SendPaymentContractReceiptAction => ({
    type: Actions.SEND_CONTRACT_PAYMENT_RECEIPT_API,
    paymentRecordIds,
})
export const sendPaymentContractReceiptApiSuccess = (success: boolean): SendPaymentContractReceiptSuccessAction => ({
    type: Actions.SEND_CONTRACT_PAYMENT_RECEIPT_API_SUCCESS,
    success,
})
export const sendPaymentContractReceiptApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.SEND_CONTRACT_PAYMENT_RECEIPT_API_ERROR,
    error,
)